import { defineMessages } from 'react-intl';

const messages = defineMessages({
  alerts: {
    description: 'accountMenuDropdown.alerts',
    defaultMessage: 'View {orderAlertCount} Alerts',
    id: '0+v67o',
  },
  myProfile: {
    description: 'accountMenuDropdown.myProfile',
    defaultMessage: 'My Profile',
    id: 'DeLKFR',
  },
  admin: {
    description: 'accountMenuDropdown.admin',
    defaultMessage: 'Admin',
    id: 'kXbkMy',
  },
  management: {
    description: 'accountMenuDropdown.management',
    defaultMessage: 'Management',
    id: '5Ud0PA',
  },
  logout: {
    description: 'accountMenuDropdown.logout',
    defaultMessage: 'Logout',
    id: 'I8pGOz',
  },
  language: {
    description: 'preferred display language',
    defaultMessage: 'Language',
    id: 'XRynTC',
  },
  manageFunds: {
    description: 'Link to open auto funding modal',
    defaultMessage: 'Manage Auto Funding',
    id: '7BI1iE',
  },
});

export default messages;
